import {
  CREATE_CANDIDATE_USER,
  CREATE_CANDIDATE_USER_FAILURE,
  CREATE_CANDIDATE_USER_SUCCESS,
  FETCH_CANDIDATE_BY_EMAIL,
  FETCH_CANDIDATE_BY_EMAIL_FAILURE,
  FETCH_CANDIDATE_BY_EMAIL_SUCCESS,
} from "./actionType";

// Create User
export const createCandidateUser = (userRequest) => ({
  type: CREATE_CANDIDATE_USER,
  payload: userRequest,
});

export const createCandidateUserSuccess = (user) => ({
  type: CREATE_CANDIDATE_USER_SUCCESS,
  payload: user,
});

export const createCandidateUserFailure = (error) => ({
  type: CREATE_CANDIDATE_USER_FAILURE,
  payload: error,
});

// Get Candidate By Email
export const fetchCandidateByEmail = (email) => ({
  type: FETCH_CANDIDATE_BY_EMAIL,
  payload: email,
});

export const fetchCandidateByEmailSuccess = (candidate) => ({
  type: FETCH_CANDIDATE_BY_EMAIL_SUCCESS,
  payload: candidate,
});

export const fetchCandidateByEmailFailure = (error) => ({
  type: FETCH_CANDIDATE_BY_EMAIL_FAILURE,
  payload: error,
});

